export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_ERROR = "GET_USERS_ERROR"
export const CREATE_CUSTOMER = "CREATE_CUSTOMER"
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER_SUCCESS"
export const CREATE_CUSTOMER_FAILURE = "CREATE_CUSTOMER_FAILURE"
export const GET_ACCOUNT_INFO = "GET_ACCOUNT_INFO"
export const GET_ACCOUNT_INFO_SUCCESS = "GET_ACCOUNT_INFO_SUCCESS"
export const GET_ACCOUNT_INFO_ERROR = "GET_ACCOUNT_INFO_ERROR"
export const GET_DASHBOARD = "GET_DASHBOARD"
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS"
export const GET_DASHBOARD_ERROR = "GET_DASHBOARD_ERROR"
export const ADD_DASHBOARD_ITEM = "ADD_DASHBOARD_ITEM"
export const ADD_DASHBOARD_ITEM_SUCCESS = "ADD_DASHBOARD_ITEM_SUCCESS"
export const ADD_DASHBOARD_ITEM_ERROR = "ADD_DASHBOARD_ITEM_ERROR"
export const DELETE_DASHBOARD_ITEM = "DELETE_DASHBOARD_ITEM"
export const DELETE_DASHBOARD_ITEM_SUCCESS = "DELETE_DASHBOARD_ITEM_SUCCESS"
export const DELETE_DASHBOARD_ITEM_ERROR = "DELETE_DASHBOARD_ITEM_ERROR"
export const SIGNUP_NEW_USER = 'SIGNUP_NEW_USER';
export const SIGNUP_NEW_USER_SUCCESS = 'SIGNUP_NEW_USER_SUCCESS';
export const SIGNUP_NEW_USER_FAILURE = 'SIGNUP_NEW_USER_FAILURE';
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS"
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS"
export const GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR"

